import { Pagination, Skeleton } from "@mui/material";
import { BackpackIcon, CalendarIcon, CaretLeftIcon, ClockIcon, DragHandleDots2Icon, EyeOpenIcon, HomeIcon, ReaderIcon, SewingPinFilledIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import DataTable from "react-data-table-component";
import { transactions } from "../../Utils/data";
import { Count } from "../../components/Widget/Count";
import { Tabs } from "../../components/Widget/Tab";
export const ListeIntention = () => {
  const [active, setActive] = useState({ index: 0, value: 'Type equipement' });
  const tabs = [{ index: 0, value: "Intention d'achât" }, { index: 1, value: 'Prise de rendez-vous' }]
  const listeIntention = [
    {
      ref: 'Ticket# 2023-CS123',
      createdAt: 'Effectué le 12/05/2024 12:10',
      name: 'Dennis Schulist',
      address: "Cocody,Palmeraie",
      type: 'Immeuble',
      status: "Intention confirmer"
    },
    {
      ref: 'Ticket# 2023-CS123',
      createdAt: 'Effectué le 02/02/2024 10:00',
      name: 'Ervin Howell',
      address: "Cocody,Palmeraie",
      type: 'Immeuble',
      status: "Intention confirmer"
    },
    {
      ref: 'Ticket# 2023-CS123',
      createdAt: 'Effectué le 12/05/2024 09:00',
      name: 'Clementine Bauch',
      address: "Cocody,Palmeraie",
      type: 'Immeuble',
      status: "Intention confirmer"
    },

  ]
  const loading = false;

  const more = () => { }

  const columns = [
    {
      name: "Nom et prenoms",
      selector: (row) => loading ? <Skeleton animation='wave' variant='text' />
        : row.client.nom,
      sortable: true,
    },
    {
      name: "Moyen de paiement",
      selector: (row) => loading ? <Skeleton animation='wave' variant='text' />
        : row.moyen_de_paiement,
    },
    {
      name: "Montant",
      selector: (row) => loading ? <Skeleton animation='wave' variant='text' />
        : row.montant + ' F CFA',
      sortable: true,
    },
    {
      name: "Date et heure",
      selector: (row) => loading ? <Skeleton animation='wave' variant='text' />
        : row.date_et_heure,
      sortable: true,
    },

    {
      name: "Status",
      selector: (row) => loading ? <Skeleton animation='wave' variant='text' />
        : <p className={`text-xs  ${row?.status ? 'bg-green-100 text-green-800 font-semibold' : 'bg-rose-100 text-rose-800 font-semibold'}  rounded-lg px-2 py-1`}>{row?.status ? 'succes' : 'encours'}</p>
    },
    {
      name: "Action",
      cell: (row) => loading ? <Skeleton animation='wave' variant='text' />
        : (
          <div className="flex items-center gap-x-3">
            <div className="tooltip" data-tip="Modifier">
              <button onClick={() => {
                // document.getElementById('add_user').showModal()
              }} className="w-7 h-7 rounded-lg bg-gray-100 flex items-center justify-center">
                <EyeOpenIcon />
              </button>
            </div>

          </div >
        ),
    },
  ];

  const rdv = [
    {
      "type": "servey",
      "status": "En cours",
      "nom": "Servey",
      "reference": "25476Rtf",
      "date": "2024-05-12",
      "heure_debut": "08:00",
      "heure_fin": "10:00"
    },
    {
      "type": "raccordement",
      "status": "Terminé",
      "nom": "Raccordement de réseau",
      "reference": "98765Abc",
      "date": "2024-05-14",
      "heure_debut": "14:00",
      "heure_fin": "16:00"
    },
    {
      "type": "servey",
      "status": "Planifié",
      "nom": "Servey de satisfaction client",
      "reference": "12345Def",
      "date": "2024-05-18",
      "heure_debut": "09:30",
      "heure_fin": "11:30"
    },
    {
      "type": "raccordement",
      "status": "En attente",
      "nom": "Raccordement électrique",
      "reference": "65432Xyz",
      "date": "2024-05-20",
      "heure_debut": "13:00",
      "heure_fin": "15:00"
    },
    {
      "type": "servey",
      "status": "Annulé",
      "nom": "Servey de satisfaction employé",
      "reference": "78910Ghi",
      "date": "2024-05-25",
      "heure_debut": "10:30",
      "heure_fin": "12:30"
    },
    {
      "type": "raccordement",
      "status": "En cours",
      "nom": "Raccordement d'eau",
      "reference": "13579Jkl",
      "date": "2024-05-28",
      "heure_debut": "11:00",
      "heure_fin": "13:00"
    }
  ]

  return (
    <div className=" ">
      <div className="lg:flex gap-8 items-center">
        <button className='btn bg-white btn-sm' onClick={() => { window.history.back() }}><CaretLeftIcon /></button>
        <div className='mt-8 flex gap-4 items-center'>
          <div className="bg-main min-w-20 min-h-20 rounded-full"></div>
          <div>
            <h3 class="text-3xl font-bold">Leanne Graham <div className="badge badge-neutral text-white">Commercial</div>
            </h3>
            <div className="mt-1 space-y-3">
              <p className="text-xs gap-2 flex"><DragHandleDots2Icon />1-770-736-8031 x56442</p>
              <p className="text-xs gap-2 flex"> <BackpackIcon />Sincere@april.biz</p>
            </div>
          </div>
        </div>
      </div>
      <Count />
      <div className="bg-white rounded-md px-4 py-4 ">
        <input type="text" placeholder="Rechercher element..." className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
        />
        <Tabs tabsData={tabs} setActive={setActive} active={active} />
        {
          active.index === 0 ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-2 my-8">
              {
                listeIntention.map((item) => (
                  <div className='bg-white border rounded-lg px-3 py-2 shadow-sm'>
                    <div className="flex items-center">
                      <div className="flex items-center gap-2">
                        <div className="bg-main min-w-4 min-h-4 rounded-full"></div>
                        <h1 className="font-bold">{item.ref}</h1>
                      </div>
                      <p className="ml-auto text-xs text-gray-400 ">{item.createdAt}</p>
                    </div>
                    <div className="mt-3 space-y-1 mb-2">
                      <p className="font-medium">{item.name}</p>
                      <div className="flex gap-1">
                        <p className="badge text-xs flex"><SewingPinFilledIcon />{item.address}</p>
                        <p className="badge text-xs flex gap-1 "><HomeIcon />{item.type}</p>
                      </div>
                    </div>
                    <div class="relative">
                      <div class="absolute inset-0 flex items-center">
                        <span class="w-full border-t"></span>
                      </div>
                      <div class="relative flex justify-center text-xs">
                      </div>
                    </div>
                    <div className='flex items-center py-2'>
                      <div className="px-3 border rounded-full py-1 text-xs text-green-600 font-medium">{item.status}</div>
                      <button className="btn btn-sm hover:bg-slate-900 font-semibold text-xs ml-auto bg-slate-900 text-white  px-3 rounded py-1">Voir l'intention</button>
                    </div>
                  </div>
                ))
              }

            </div>
          ) : active.index === 1 ? (
            <div>
              <div className="flex mt-3 gap-1">
                <div className={`hover:bg-gray-50 cursor-pointer px-3 border rounded-full py-1 text-xs text-gray-600 font-semibold`}>En attente</div>
                <div className={`hover:bg-gray-50 cursor-pointer px-3 border rounded-full py-1 text-xs text-orange-600 font-semibold`}>En cours</div>
                <div className={`hover:bg-gray-50 cursor-pointer px-3 border rounded-full py-1 text-xs text-green-600 font-semibold`}>Realisé</div>
              </div>

              <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-2 my-4">
                {
                  rdv.map((item) => (
                    <div className='bg-white rounded-xl border-slate-200 border px-3 py-2 shadow-sm'>
                      <p className="text-xs">Ticket N°323258-4</p>
                      <div className="my-1 flex items-center">
                        <div className="flex items-center gap-2">
                          <div className={`px-3 border rounded-full py-1 text-xs ${item.status === 'En cours' ? 'text-orange-600' : 'text-green-600'}  font-semibold`}>{item.status}</div>
                          <div className="px-3 border rounded-full py-1 text-xs flex gap-1"><ReaderIcon />{item.type} </div>
                        </div>
                      </div>
                      <div className="items-center gap-2 space-y-2">
                        <h1 className="font-bold ">{item.reference}</h1>
                        <div className="flex gap-4 items-center">
                          <p className="text-xs flex gap-1 items-center font-medium"><CalendarIcon />{item.date}</p>
                          <p className="text-xs flex gap-1 font-medium"><ClockIcon /> {item.heure_debut}</p>
                        </div>

                      </div>
                      <div className="mt-3 space-y-1 mb-2">
                        <div className="flex gap-1">
                        </div>
                      </div>
                    </div>
                  ))
                }

              </div>
            </div>
          ) : (
            <div className="mt-2 border rounded-lg">
              <DataTable
                columns={columns}
                data={transactions}
                progressPending={loading}
                customStyles={{
                  headCells: {
                    style: {
                      backgroundColor: '#f9f7f7',
                      color: 'gray',
                      fontWeight: "normal",
                      fontSize: 14
                    },
                  },
                }}
                progressComponent={
                  <span class="loading loading-spinner loading-lg"></span>
                }
                noDataComponent='Aucune donnée'
              />

            </div>
          )
        }
        <div className='my-3 flex justify-end'>
          <Pagination onChange={(event, newValue) => more(newValue)}
            onSelect={selectedPage => more(selectedPage)} count={listeIntention.length} variant="outlined" color='primary' shape="rounded" />
        </div>
      </div>
    </div>
  )

}
